import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import type { DayHoursMode } from "Components/Shared/Inputs/OpeningHoursInput/DayHoursRow/types";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.Facilities.Form.OpeningHours;

type Props = {
  value: DayHoursMode;
  onChange: (mode: DayHoursMode) => void;
};

export const DayModeSelector = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <FormControl component="fieldset" fullWidth>
      <RadioGroup
        row
        value={value}
        onChange={(e) => onChange(e.target.value as DayHoursMode)}
        sx={{ flexDirection: ["column", "row"], gap: [0.5, 0] }}
      >
        <FormControlLabel
          value="range"
          control={<Radio />}
          label={t(RESOURCES.TimeRange)}
          sx={{ mr: [0, 2] }}
        />
        <FormControlLabel
          value="openAllDay"
          control={<Radio />}
          label={t(RESOURCES.OpenAllDay)}
          sx={{ mr: [0, 2] }}
        />
        <FormControlLabel
          value="closedAllDay"
          control={<Radio />}
          label={t(RESOURCES.ClosedAllDay)}
          sx={{ mr: [0, 2] }}
        />
      </RadioGroup>
    </FormControl>
  );
};
